import { Injectable } from '@angular/core';
import {MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';
import {ParametrosConst} from './parametrosConst';

@Injectable({
  providedIn: 'root'
})
export class AlertaService {

  constructor(public snackBar: MatSnackBar) {
  }

  success(message: any) {
    if (typeof (message) === 'string') {
      this.showSnackBar(message + '', ParametrosConst.CLASS_CSS_SUCCESS);
    }
    if (message instanceof Object && typeof message.message !== 'undefined') {
      this.showSnackBar(message.message, ParametrosConst.CLASS_CSS_SUCCESS);
    }
    if (message instanceof Array && message.length > 0 && typeof message[0].message !== 'undefined') {
      this.showSnackBar(message[0].message, ParametrosConst.CLASS_CSS_SUCCESS);
    }
  }

  error(message: string) {
    this.showSnackBar(message, ParametrosConst.CLASS_CSS_ERROR);
  }

  info(message: string) {
    this.showSnackBar(message, ParametrosConst.CLASS_CSS_INFO);
  }

  warning(message: string) {
    this.showSnackBar(message, ParametrosConst.CLASS_CSS_WARNING);
  }

  showSnackBar(message: string, classCss: string) {
    const config = new MatSnackBarConfig();
    config.verticalPosition = ParametrosConst.VERTICAL_POSTION;
    config.horizontalPosition = ParametrosConst.HORIZONTAL_POSITION;
    config.duration = ParametrosConst.TIEMPO_DURACION_ALERTA;
    config.panelClass = classCss;
    this.snackBar.open(message, 'X', config);
  }
}
